import { motion, useReducedMotion } from "motion/react";
import { useTheme } from "../context/ThemeContext";

export default function MesaHeader({ table, cartCount, onToggleCart }) {
  const reduced = useReducedMotion();
  const { theme, toggleTheme } = useTheme();
  const isActive = table?.active === true || table?.active === 1;

  return (
    <header className="mesa-header">
      <div className="mesa-header-brand">
        <span className="mesa-header-logo">NEON</span>
        {table && (
          <span className={`mesa-header-badge${isActive ? " active" : " inactive"}`}>
            Mesa {table.number}
          </span>
        )}
      </div>
      <div className="mesa-header-actions">
        <button
          type="button"
          className="mesa-header-theme"
          onClick={toggleTheme}
          aria-label={theme === "night" ? "Modo día" : "Modo noche"}
          title={theme === "night" ? "Modo día" : "Modo noche"}
        >
          <span className={`mesa-theme-icon ${theme === "night" ? "sun" : "moon"}`} aria-hidden="true" />
        </button>
        <motion.button
          type="button"
          className="mesa-header-cart"
          onClick={onToggleCart}
          whileTap={reduced ? undefined : { scale: 0.9 }}
          aria-label="Ver pedido"
          aria-expanded={false}
        >
          <span className="mesa-cart-icon" aria-hidden="true" />
          {cartCount > 0 && <span className="mesa-header-count">{cartCount}</span>}
        </motion.button>
      </div>
    </header>
  );
}
